'use strict';
module.exports = new Set(require('./spdx-simple.json'));
